import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PostGraduateEducationModuleItem, PostGraduateEducationModule } from '../models';

export class PostGraduateEducationModuleApi extends ApiModule {
  protected endpoint = '/post-graduate-education-module';

  public async pagePostGraduateEducationModules(params: any) {
    return this.api.post<PaginatedResponseData<PostGraduateEducationModuleItem>, any>(`${this.endpoint}/page`, {
      ...params
    });
  }

  public loadPostGraduateEducationModuleDetails(id: number) {
    return this.api.get<PostGraduateEducationModule>(`${this.endpoint}?id=${id}`);
  }

  public savePostGraduateEducationModule(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePostGraduateEducationModule(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
